import React from 'react'
import { useLocale } from 'src/lib/hooks/useLocal'
import { SubscriptionPlanDraft } from 'src/lib/types/subscriptions'
import { formatPlanDuration, formatPlanFrequency } from 'src/lib/utils/subscriptions/subscriptionHelpers'

export const DATE_PLACEHOLDER = '{date}'

export const planDeliveryCount = (plan: SubscriptionPlanDraft) =>
  plan.durationValue && plan.intervalCount ? Math.floor(plan.durationValue / plan.intervalCount) : null

export const PlanTitle = ({ plan, className }: { plan: SubscriptionPlanDraft; className?: string }) => {
  const { t } = useLocale()
  const duration = formatPlanDuration(plan, t)

  return (
    <span className={`font-semibold text-black/80 ${className ?? ''}`}>
      {t('subscriptions.plan_every')} {formatPlanFrequency(plan, t)}{' '}
      {duration ? (
        <>
          <span className='font-medium text-black/40'>{t('subscriptions.plan_for')}</span> {duration}
        </>
      ) : (
        <span className='font-medium text-black/40'>{t('subscriptions.plan_until_cancelled')}</span>
      )}
    </span>
  )
}
